'use client';
import { useState } from 'react';
import { motion, AnimatePresence  } from 'framer-motion';
import { MODES, getScaleNotes, SCALE_DEGREES } from '../../config/musicTheory';

function ScaleNotesButton({root, mode}) {
  const [open, setOpen] = useState(false);

  const modeInfo = MODES[mode];
  if (!modeInfo) {
    console.error(`Invalid mode: ${mode}`);
    return <div>Invalid scale type</div>;
  }
  
  const { intervals } = modeInfo;

  const scaleNotes = getScaleNotes(root, mode);

  return (
    <div className="relative w-[40px] shrink-0">
      {/* Button Closed */}
      {!open && (
        <div className="tooltip" data-tip="Show Notes">
          <button
            className="btn btn-primary btn-md w-[40px] p-0"
            onClick={() => setOpen(true)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
              <path strokeLinecap="round" strokeLinejoin="round" d="m9 9 10.5-3m0 6.553v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 1 1-.99-3.467l2.31-.66a2.25 2.25 0 0 0 1.632-2.163Zm0 0V2.25L9 5.25v10.303m0 0v3.75a2.25 2.25 0 0 1-1.632 2.163l-1.32.377a1.803 1.803 0 0 1-.99-3.467l2.31-.66A2.25 2.25 0 0 0 9 15.553Z" />
            </svg>
          </button>
        </div>
      )}

      {/* Button Open */}
      <AnimatePresence >
        {open && (
          <motion.div
            key="scale-notes"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="absolute -top-4 left-0 z-10 card shadow-lg p-2 w-auto bg-base-100 border border-neutral"
          >
            <div className="flex justify-between items-start">
              <label className="label" htmlFor="scale-notes">Scale Notes</label>
              <button
                onClick={() => setOpen(false)}
                className="btn btn-xs btn-circle btn-ghost"
              >
              ✕
              </button>
            </div>
            <div className="flex gap-2 mt-2">
              {scaleNotes.map((note, index) => {
                const interval = intervals[index];
                const degreeInfo = SCALE_DEGREES[interval.replaceAll(/[#♭]/g, '')] || {};
                const tooltipText = degreeInfo.function ? `${degreeInfo.name} - ${degreeInfo.function}` : '';
                
                return (
                  <div key={interval} className="tooltip tooltip-bottom" data-tip={tooltipText}>
                    <div
                      className={`badge badge-lg ${
                        note === root ? 'badge-primary' : 'badge-ghost'
                      }`}
                    >
                      <span className="font-medium">{note}</span>
                      <span className="text-xs ml-1 opacity-70">
                        ({interval})
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default ScaleNotesButton;
